/* eslint-disable */
// TagSelect for Form
// modalProps -- CheckableTag 相关定制设置
// actionChange: 父级组件回调方法
import React from 'react'
import { Tag } from 'antd'

const { CheckableTag } = Tag

const I2TagSelectForm = (props) => {
  const {
    id,
    modalProps, radio,
    options, value,
    actionChange, onChange,
    disableOptionType, disableOption
  } = props

  const useValue = Array.isArray(value) ? value : (value ? String(value).split(',') : [])

  const handleOptionDisable = (item) => {
    if (item.selectDisabled) { return true }
    if (disableOptionType) {
      return disableOption.some(d => d[disableOptionType] === item.id)
    }
  }

  const onChangeSelect = (itemId, state) => {
    let formatValue
    if (radio) {
      formatValue = state ? [itemId] : []
    } else {
      formatValue = state
        ? [...useValue, itemId]
        : useValue.filter(ele => String(ele) !== String(itemId))
    }
    console.log('[I2TagSelectForm] formatValue:', formatValue)
    onChange(formatValue)
    if (actionChange) {
      actionChange(formatValue)
    }
  }

  return (
    <div id={id} className="i2-radio-tag">
      {options.map(item => (
        <CheckableTag
          {...modalProps}
          key={item.id}
          checked={useValue.some(v => String(v) === String(item.id))}
          disabled={handleOptionDisable(item)}
          onChange={(state) => onChangeSelect(item.id, state)}
        >
          {item.value}
        </CheckableTag>
      ))}
    </div>
  )
}

export default I2TagSelectForm

I2TagSelectForm.defaultProps = {
  modalProps: {},
  options: [],
  radio: false,
  disableOptionType: false,
  disableOption: []
}
